(function () {
  'use strict';

  var container = document.getElementById('load-more-container');
  if (!container) return;

  var btn = document.getElementById('load-more-btn');
  var grid = document.getElementById('product-grid');
  if (!btn || !grid) return;

  var collectionUrl = container.dataset.collectionUrl;
  var sectionId = container.dataset.sectionId;
  var currentPage = parseInt(container.dataset.currentPage, 10) || 1;
  var hasNextPage = true;

  function setLoading(loading) {
    var text = btn.querySelector('.load-more-btn__text');
    var spinner = btn.querySelector('.load-more-btn__spinner');
    btn.disabled = loading;
    if (text) text.style.display = loading ? 'none' : '';
    if (spinner) spinner.style.display = loading ? '' : 'none';
  }

  function loadMore() {
    if (!hasNextPage) return;

    setLoading(true);

    var nextPage = currentPage + 1;
    var url = collectionUrl
      + '?section_id=' + encodeURIComponent(sectionId)
      + '&page=' + nextPage;

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newItems = doc.querySelectorAll('#product-grid .grid__item');

        newItems.forEach(function (item) {
          grid.appendChild(item);
        });

        currentPage = nextPage;
        // A load-more-container in the fetched page means Shopify's own
        // paginate.next was still truthy for that page.
        hasNextPage = !!doc.getElementById('load-more-container');

        if (!hasNextPage) {
          container.style.display = 'none';
        } else {
          setLoading(false);
        }
      })
      .catch(function (err) {
        console.error('[load-more] fetch failed:', err);
        setLoading(false);
      });
  }

  btn.addEventListener('click', loadMore);
})();
